import {
  createAsyncThunk,
} from '@reduxjs/toolkit';

import type { ThunkApiType } from '@/store';
import type { DrugJson } from '@/types/domain/drug/entities/drugEntity';

import { drugSlice } from '@/domain/drug/redux';
import { service } from '@/share';

export const refreshDrugList = createAsyncThunk<
  void,
  void,
  ThunkApiType
>(
  'drug/refreshDrugList',
  async (_, thunkApi) => {
    const result: {
      items: DrugJson[],
      nextToken: string,
    } = await service.drug.getDrugList(null);
    thunkApi.dispatch(drugSlice.actions.setDrugList(result));
  },
);

export const getDrugList = createAsyncThunk<
  void,
  void,
  ThunkApiType
>(
  'drug/getDrugList',
  async (_, thunkApi) => {
    const { nextToken, drugList } = thunkApi.getState().drug;
    if (!nextToken) {
      if (drugList.length === 0) {
        thunkApi.dispatch(refreshDrugList());
      }
      return;
    }
    const result: {
      items: DrugJson[],
      nextToken: string,
    } = await service.drug.getDrugList(nextToken);
    const newList = drugList.map((v) => v);
    for (let i = 0; i < result.items.length; i += 1) {
      newList.push(result.items[i]);
    }
    thunkApi.dispatch(drugSlice.actions.setDrugList({
      /** データ */
      items: newList,
      /** 次のトークン */
      nextToken: result.nextToken,
    }));
  },
);

export const createDrug = createAsyncThunk<
  void,
  {
    /** データ */
    data: DrugJson,
    /** 施設IDリスト */
    facilityIds: string[],
  },
  ThunkApiType
>(
  'drug/create',
  async (input, _thunkApi) => {
    await service.drug.createDrug(input.data);
    if (input.facilityIds.length > 0) {
      const promises = input.facilityIds.map(
        (v) => service.drugNursery.sendNurseryDrug({
          data: input.data.data,
          pub: {
            sendId: input.data.pub.sendId,
            replyId: v,
            data: { ...input.data.pub.data },
          },
        }),
      );
      await Promise.all(promises);
    }
  },
);

export const deleteDrug = createAsyncThunk<
  void,
  {
    /** データ */
    data: DrugJson,
    /** 施設IDリスト */
    facilityIds: string[],
  },
  ThunkApiType
>(
  'drug/delete',
  async (input, _thunkApi) => {
    await service.drug.deleteDrug(input.data);
    if (input.facilityIds.length > 0) {
      const promises = input.facilityIds.map(
        (v) => service.drugNursery.removeNurseryDrug({
          data: input.data.data,
          pub: {
            sendId: input.data.pub.sendId,
            replyId: v,
            data: { ...input.data.pub.data },
          },
        }),
      );
      await Promise.all(promises);
    }
  },
);
